export const name = 'usdcoin_ftx'
export const displayName = 'USD'
export const ticker = 'USDCFTX'
export const displayTicker = 'USD'
export const units = {
  base: 0,
  USDCFTX: 8,
}
export const assetType = 'CUSTODIAL_FTX'

export const combinedAssetNames = ['usdcoin']

export const info = {
  description:
    'USDC, BUSD, USDP, TUSD, and HUSD all count as "USD" balance in FTX. You can deposit and withdraw USD via Exodus through USDC on Ethereum.',
}
